import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

const FieldHeading = ({ field }) => {
	return <Text style={{ fontWeight: "bolder" }}>{field}</Text>;
};

export default FieldHeading;
